<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',

  created() {
    ;(function(window) {
      var theUA = window.navigator.userAgent.toLowerCase()
      if (
        (theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) ||
        (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])
      ) {
        var ieVersion =
          theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] ||
          theUA.match(/trident\s?\d+/)[0]
        if (ieVersion < 10) {
          var str = '你的浏览器版本太旧了\n已经和时代脱轨了 :('
          var str2 =
            "\n推荐您使用:<a href='https://www.google.cn/intl/zh-CN/chrome/' target='_blank' style='color:#e83030; font-weight:bold; font-size:30px'>谷歌</a>," +
            "<a href='http://www.firefox.com.cn/' target='_blank' style='color:#e83030; font-weight:bold; font-size:30px'>火狐</a>," +
            "<a href='https://www.liebao.cn/' target='_blank' style='color:#e83030; font-weight:bold; font-size:30px'>猎豹</a>,其他双核急速模式再来使用"
          document.writeln(
            "<pre style='text-align:center;color:#fff;background-color:#0cc; height:100%;border:0;position:fixed;top:0;left:0;width:100%;z-index:1234'>" +
              "<h2 style='padding-top:200px;margin:0'><strong>" +
              str +
              '<br/></strong></h2><p>' +
              str2 +
              "</p><h2 style='margin:0'><strong>如果你的使用的是双核浏览器,请切换到极速模式访问<br/></strong></h2></pre>"
          )
          document.execCommand('Stop')
        }
      }
    })(window)
  }
}
</script>

<style>
body {
  overflow-x: hidden;

}
.el-popover{
    color: red !important;
    background: #D3D3D3;
  }
</style>
